import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Leaderboard } from './Leaderboard';

export default function LeaderboardPage() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700;800;900&family=Rajdhani:wght@300;400;500;600;700&display=swap');
        
        @keyframes gridMove {
          0% { transform: perspective(500px) rotateX(60deg) translateY(0); }
          100% { transform: perspective(500px) rotateX(60deg) translateY(50px); }
        }
        
        @keyframes scanLine {
          0% { top: -10%; }
          100% { top: 110%; }
        }
        
        @keyframes logoGlow {
          0% { filter: drop-shadow(0 0 10px rgba(0, 245, 255, 0.5)); }
          100% { filter: drop-shadow(0 0 20px rgba(255, 0, 255, 0.5)); }
        }

        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Rajdhani', sans-serif; }
      `}</style>

      <div style={{
        minHeight: '100vh',
        background: '#0a0a0f',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Grid Background */}
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'linear-gradient(rgba(0, 245, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 245, 255, 0.03) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          animation: 'gridMove 20s linear infinite',
          pointerEvents: 'none',
          zIndex: 0
        }} />

        {/* Scan Line */}
        <div style={{
          position: 'fixed',
          height: '2px',
          width: '100%',
          left: 0,
          background: 'linear-gradient(90deg, transparent, #00f5ff, transparent)',
          animation: 'scanLine 8s linear infinite',
          pointerEvents: 'none',
          zIndex: 1
        }} />

        {/* Main Content */}
        <div style={{ position: 'relative', zIndex: 10 }}>
          {/* Header */}
          <header style={{
            padding: '20px 40px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid rgba(0, 245, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            position: 'sticky',
            top: 0,
            zIndex: 100,
            background: 'rgba(10, 10, 15, 0.8)'
          }}>
            {/* Back Button */}
            <Link 
              to="/" 
              style={{ 
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 20px',
                background: 'rgba(0, 245, 255, 0.1)',
                border: '1px solid rgba(0, 245, 255, 0.3)',
                borderRadius: '8px',
                color: '#00f5ff',
                fontFamily: "'Orbitron', monospace",
                fontSize: '0.9rem',
                fontWeight: '600',
                transition: 'all 0.3s ease'
              }}
            >
              <ArrowLeft size={18} />
              Back to Games
            </Link>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem', // Space between logo text and image
            }}>
              <img 
                src={`${process.env.PUBLIC_URL}/cug-games.png`}
                alt="HighMind Logo"
                style={{
                  width: '3.5rem',
                  height: '3.5rem',
                }}
              />
            <div style={{
              fontFamily: "'Orbitron', monospace",
              fontSize: '2rem',
              fontWeight: '900',
              background: 'linear-gradient(135deg, #00f5ff, #ff00ff)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '4px',
              animation: 'logoGlow 2s ease-in-out infinite alternate'
            }}>
              CUGS//GAMES
            </div>
            </div>

            {/* Spacer for centering */}
            <div style={{ width: '150px' }} />
          </header>

          {/* Leaderboard Content */}
          <Leaderboard />

          {/* Footer */}
          <footer style={{
            padding: '40px',
            textAlign: 'center',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            marginTop: '60px'
          }}>
            <p style={{ color: 'rgba(255, 255, 255, 0.3)', fontSize: '0.9rem' }}>
              © 2025 CUGS GAMES • Built for fun, played for glory
            </p>
          </footer>
        </div>
      </div>
    </>
  );
}